//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import Vue from "vue";
import { integer, decimal } from "vuelidate/lib/validators";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import ErrorsIcon from "@/assets/images/TaskErrorsIcon.svg";
import ErrorsIconHover from "@/assets/images/TaskErrorsIconHover.svg";

import VueApexCharts from "vue-apexcharts";
import { extend } from "quasar";
import { detailedDiff } from "deep-object-diff";
import { addWindowResizeCallback } from "@/assets/js/appResize";
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";

import plvTaskDescription from "@/components/Diagrams/sidebar/plv-task-description.vue";
import { AgGridVue } from "ag-grid-vue";
import _get from "lodash.get";
import _set from "lodash.set";
import _setWith from "lodash.setwith";
import _has from "lodash.has";
import AppTracer from "../../components/Flow/appTracer.vue";
import { $http } from "@/assets/js/appFunc";

import InterfaceLoad from "../../components/UserInterfaces/mixins/interface-load";
import ComponentsLoading from "../../components/UserInterfaces/mixins/components-loading";
import DataUtils from "./mixins/data-utils";
import Events from "../../components/UserInterfaces/mixins/events";
import DataModel from "../../components/UserInterfaces/mixins/datamodel-utils";
import InterfaceUtils from "../../components/UserInterfaces/mixins/interface-utils";

import QfComponentsPage from "../../components/UserInterfaces/qf-components-page.vue";
import QfComponentsRenderer from "../../components/UserInterfaces/qf-components-renderer.vue";
import QfMAppTimeline from "./modals/qf-m-app-timeline.vue";
import QfMAppDocuments from "./modals/qf-m-app-documents.vue";
import QfMAppComments from "./modals/qf-m-app-comments.vue";
import QfMAppErrors from "@/pages/fabricInterface/modals/qf-m-app-errors";

import FabRightMenu from "./components/FabRightMenu.vue";
import FabHeaderMenu from "./components/FabHeaderMenu.vue";
import FabDrawerMenu from "./components/FabDrawerMenu.vue";
import FabRightDrawerErrors from "./components/FabRightDrawerErrors.vue";
import FabFooterMenu from "./components/FabFooterMenu.vue";

import QfField from "../../components/UserInterfaces/components/field/QfField.vue";
import QfSelect from "../../components/UserInterfaces/components/select/QfSelect.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQDateTimePicker from "@/components/UserInterfaces/components/datetimepicker/AQDateTimePicker";
import FroalaComponent from "@/components/UserInterfaces/components/froala/FroalaComponent.vue";
import MediaRecorder from "./components/media-recorder-plugin/media-recorder.vue";
import AQPdfViewer from "./components/pdf-preview-modal/AQPdfViewer.vue";
import AWalletSign from "@/components/Generics/AWallet/AWalletSign.vue";
import FabHeaderMenuActions from "@/pages/fabricInterface/components/FabHeaderMenuActions.vue";
import AIPromptTask from "./components/AIPromptTask.vue";

import roboOrg from "@/assets/images/robo_orange.svg";
import closeI from "@/assets/images/close_24px.svg";

Vue.component("QfField", QfField);
Vue.component("QfSelect", QfSelect);
Vue.component("AgGridVue", AgGridVue);
Vue.component("AQDateTimePicker", AQDateTimePicker);
Vue.component("FroalaComponent", FroalaComponent);
Vue.component("MediaRecorder", MediaRecorder);
Vue.component("AQPdfViewer", AQPdfViewer);
Vue.component("AQUploader", AQUploader);
Vue.component("AWalletSign", AWalletSign);
Vue.use(VueApexCharts);
Vue.component("Apexchart", VueApexCharts);

const cleanKeys = (dataObject, keys) => {
    const objectParse = data => {
        if (!data) { return data; }

        let bigData;
        if (data.constructor === Array) {
            bigData = [];
            data.forEach(entry => {
                bigData.push(entry ? objectParse(entry) : null);
            });
        } else if (data.constructor === Object) {
            bigData = {};
            Object.entries(data).forEach(([key, value]) => {
                if (keys.indexOf(key) === -1) {
                    bigData[key] = objectParse(value);
                }
            });
        } else {
            bigData = data;
        }

        return bigData;
    };

    return dataObject ? objectParse(dataObject) : null;
};

export default {
    components: {
        FabHeaderMenuActions,
        AppTracer,
        AQDialog,
        AQTooltip,
        FabFooterMenu,
        FabDrawerMenu,
        FabRightDrawerErrors,
        FabRightMenu,
        FabHeaderMenu,
        QfMAppComments,
        QfMAppDocuments,
        QfMAppTimeline,
        QfMAppErrors,
        plvTaskDescription,
        QfComponentsPage,
        QfComponentsRenderer,
        MediaRecorder,
        AQCard,
        AQModal,
        AWalletSign,
        AIPromptTask
    },
    mixins: [InterfaceUtils, InterfaceLoad, ComponentsLoading, DataUtils, Events, DataModel],
    data() {
        return {
            invalidInputData: false,
            taskSelected: false,
            miniRight: true,
            appMenu: true,
            footerMenu: true,
            appState: "flow",
            flow: null,
            modalInformation: false,
            modalTimeline: false,
            modalDocuments: false,
            modalErrors: false,
            modalComments: false,
            templateFragment: null,
            templateData: null,
            oldTemplateData: null,
            submitAction: null,
            submitActionsList: [],
            save: {},
            loadedData: {},
            showDebug: false,
            actionDetails: {},
            comment: null,
            errors: false,
            modalSubmit: false,
            showProcessInfo: false,
            loading: true,
            errorMessage: "There was a problem while loading the task interface",
            actionMessage: this.$t("tasks.unclaimMessage"),
            unwatchOnChange: null,
            loadedTheme: {},
            showActionMessage: false,
            showRedBullet: false,
            hasGui: true,
            showRightMenu: false,
            showLandscapeMsg: false,
            errorList: [],
            goBack: false,
            lastDiffSignature: null,
            invalidFields: [],
            hasSidebarPermission: false,
            rightDrawerOpen: false,
            hoverIcon: false,
            taskErrorsIcon: `img:${ErrorsIcon}`,
            taskErrorsIconHover: `img:${ErrorsIconHover}`,
            maintenanceSchedule: false,
            maintenanceMessage: "",
            interfaceDirty: false,
            errorInJump: null,
            wrongTenant: false,
            defaultLanguage: "en",
            sideBarPermissions: {},
            isOwner: false,
            roboIconOrange: `img:${roboOrg}`,
            closeIcon: `img:${closeI}`,
            promptOpened: false,
            elementsListCheckError: ["ctrl-upload", "ctrl-toggle", "ctrl-slider", "ctrl-radio", "ctrl-mselect", "ctrl-select", "ctrl-datetimepicker", "ctrl-checkbox", "ctrl-autocomplete"]
        };
    },
    props: {
        taskParams: {
            type: Object,
            default: () => {}
        },
    },
    computed: {
        ...mapState("components", [
            "fragments",
            "data",
            "properties",
            "components",
            "readOnly",
            "bodyReference",
            "activityId",
            "isSmallScreen",
            "workInProgress",
            "legacyElementState",
            "parsed",
            "resetId",
            "aiActions"
        ]),
        ...mapState("userProfile", ["needsTaskRedirect"]),
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("diagrams", ["getHasNewComments"]),
        ...mapGetters("components", ["body", "getAssistantVis", "getAssistantForceOpen"]),
        ...mapGetters("userProfile", ["userCookieInfo", "userDataDetails"]),
        ...mapGetters("main", ["getShowEnableTaskAI"]),
        isFlow() { return this.appState === "flow"; },
        errorsIcon() {
            return this.hoverIcon ? this.taskErrorsIconHover : this.taskErrorsIcon;
        },
        showAIPrompt() {
            return this.aiActions.length && this.getShowEnableTaskAI && this.getAssistantVis;
        },
        getIconBtn() {
            return this.promptOpened || this.getAssistantForceOpen ? this.closeIcon : this.roboIconOrange;
        },
        weHaveErrors() {
            return this.invalidFields.length !== 0;
        },
        showDrawerMenu() {
            return this.canShow || this.showRightMenu;
        },
        title() {
            const { activityName = "", subject = "" } = this.flow;
            return subject || activityName;
        },
        subtitle() {
            const { processDefinitionName = "", processInstanceName = "" } = this.flow;
            let title;

            if (processDefinitionName) {
                title = processDefinitionName;
            } else if (processInstanceName) {
                const [process] = processInstanceName.split(";");
                title = process;
            }

            return title;
        },
        processInstanceId() {
            return this.flow && this.flow.hasOwnProperty("processInstanceId") ? this.flow.processInstanceId : null;
        },
        applicationId() {
            let appIdToReturn = null;
            if (this.flow) {
                appIdToReturn = this.flow.data?.applicationId || this.flow.applicationId;
            }
            return appIdToReturn;
        },
        getPerspectiveId() {
            return this.flow?.perspectiveId;
        },
        processDefinitionId() {
            return this.flow && this.flow.hasOwnProperty("processDefinitionId") ? this.flow.processDefinitionId : null;
        },
        taskId() {
            let taskId = null;
            if (this.flow) {
                if (this.flow.hasOwnProperty("taskId")) {
                    taskId = this.flow.taskId;
                } else if (this.flow.hasOwnProperty("id")) {
                    taskId = this.flow.id;
                }
            }
            return taskId;
        },
        isManager() {
            return this.flow && this.flow.hasOwnProperty("__isManager") && this.flow.__isManager;
        },
        fromAdmin() {
            return this.flow && this.flow.hasOwnProperty("__fromAdmin") && this.flow.__fromAdmin;
        },
        isReadOnly() {
            return this.flow && this.flow.hasOwnProperty("__readonly") ? this.flow.__readonly : false;
        },
        isFromPLV() {
            return this.flow && this.flow.hasOwnProperty("__reports") ? this.flow.__reports : false;
        },
        canUnclaim() {
            return this.flow && this.flow.hasOwnProperty("canUnclaim") ? this.flow.canUnclaim : false;
        },
        canReassign() {
            return this.flow && this.flow.hasOwnProperty("canReassign") ? this.flow.canReassign : false;
        },
        canEscalate() {
            return this.flow && this.flow.hasOwnProperty("canEscalate") ? this.flow.canEscalate : false;
        },
        isExternalFromReports() {
            return this.flow && this.flow.hasOwnProperty("taskExternalReports") ? this.flow.taskExternalReports : false;
        },
        showExternalPhone() {
            return this.flow && this.flow.hasOwnProperty("externalPhone") ? this.flow.externalPhone : false;
        },
        getReassignUserList() {
            return this.flow && this.flow.hasOwnProperty("reassignUserList") ? this.flow.reassignUserList : null;
        },
        taskType() {
            let taskType = null;
            if (this.flow) {
                if (this.flow.hasOwnProperty("taskType")) {
                    taskType = this.flow.taskType;
                } else if (this.flow.hasOwnProperty("type")) {
                    taskType = this.flow.type;
                }
            }

            return taskType;
        },
        isApprovalTask() {
            return this.taskType === "APPROVALLEVEL_PLUGIN";
        },
        isStandardTask() {
            return this.taskType === "TASK_PLUGIN";
        },
        canShow() {
            return !this.loading && !this.errors;
        },
        showMobileFooter() {
            return !(this.isSmallScreen && this.isReadOnly && !this.canUnclaim && !this.canReassign && !this.canEscalate);
        },
        isExternalTask() {
            return this.flow && this.flow.isExternalTask;
        },
        isCompletedTask() {
            return this.flow && this.flow.hasOwnProperty("__tasksCompleted") ? this.flow.__tasksCompleted : false;
        }
    },
    watch: {
        flow(val) {
            if (val) {
                this.setReadonly(this.isReadOnly);
                this.setCurrentApplicationId(this.processDefinitionId);
                if (!Object.keys(this.currentApp).length) {
                    let appId = "";
                    const appIdfromSession = JSON.parse(sessionStorage.getItem("currentApp"));
                    if (val.applicationId) {
                        appId = val.applicationId;
                    } else if (val.data && val.data.applicationId) {
                        appId = val.data.applicationId;
                    } else if (appIdfromSession && appIdfromSession.id) {
                        appId = appIdfromSession.id;
                    }
                    this.$store.commit("apps/setCurrentApp", { id: appId });
                }
                this.setProcessInstanceId(val.processInstanceId);
                this.setActivityId(val.activityId);
                this.setTaskId(this.taskId);
            }
        },
        templateData: {
            deep: true,
            handler(value) {
                if (value) {
                    this.interfaceDirty = true;
                };
            }
        },
        __changeEvents(value) {
            if (value) {
                if (this.unwatchOnChange) {
                    this.unwatchOnChange();
                }
                this.unwatchOnChange = this.$watch("templateData", this.changeHandler, { deep: true });
            }
        }
        // might be used in the future, commented for now
        // "$backendDrivenEvents.state.taskDataNotifications": function(taskDetails) {
        //     if (taskDetails) {
        //         const splitRequest = taskDetails.split(" : ");
        //         let checkIsReassign;
        //         if (splitRequest.length > 1) {
        //             checkIsReassign = splitRequest[0] === "reassigned";
        //         }
        //         this.$toast.showNotify({
        //             type: "info",
        //             message: checkIsReassign ? this.$t("tasks.newTaskReassignedFabricI") : this.$t("tasks.newTaskAssignedFabricI"),
        //             timeout: 6000
        //         });
        //     }
        // }
    },
    beforeCreate() {
        window.Vue = Vue;
    },
    created() {
        const wrongTenant = JSON.parse(localStorage.getItem("wrongTenantActive"));
        this.setWorkInProgress(true);
        if (!wrongTenant) {
            this.actBrandName().then(data => {
                document.title = data.companyName;
            });
        }

        let flow = {};

        if (Object.keys(this.taskParams).length) {
            flow = {
                ...this.taskParams
            }
        }

        if (Object.keys(flow).length) {
            sessionStorage.setItem("taskId", flow.taskId || flow.id);
            this.flow = { ...flow };
        } else {
            this.loading = false;
            this.errors = true;
        }

        if (this.errors) {
            this.$toast.showNotify({
                type: "error",
                message: "Interface load parameters are incorrect.",
                code: "app-loadNOk",
                timeout: 2000
            });
        } else {
            // let promise = this.isReadOnly ? Promise.resolve(true) : this.claimTask(this.taskId);
            const promise = Promise.resolve(true);

            promise.then(data => {
                if (data) {
                    if (flow.guiId) {
                        this.starInterfaceLoad();
                    } else {
                        this.hasGui = false;
                        this.showRightMenu = true;
                    }
                } else {
                    this.errors = true;
                    this.loading = false;
                    this.$toast.showNotify({
                        type: "error",
                        message: "Could not claim the task.",
                        code: "app-claimNOk",
                        timeout: 2000
                    });
                }
            });
        }
        let appIdForCall = "";
        if (this.flow) {
            if (this.flow.data && this.flow.data.applicationId) {
                appIdForCall = this.flow.data.applicationId;
            } else if (this.flow.applicationId) {
                appIdForCall = this.flow.applicationId;
            } else {
                appIdForCall = JSON.parse(sessionStorage.getItem("currentApp")).id;
            }
        }
        this.actGetUserSystemPermissions();
        this.actGetCurrentAppUserPermissions(appIdForCall).then(rsp => {
            const checkSideBarPermissions = (code) => {
                const sidebarPermissions = ["CM", "DC", "ST", "TL"];
                const checkInsideRole = () => (sidebarPermissions.filter(type => rsp[code][type] && rsp[code][type].g === "w"));
                return (rsp[code].g && rsp[code].g === "w") || checkInsideRole();
            }
            if (rsp.hasOwnProperty("g")) {
                this.hasSidebarPermission = rsp.g === "o";
                this.isOwner = true;
            } else {
                this.hasSidebarPermission = Object.keys(rsp).find(uiCode => uiCode === "SB" && checkSideBarPermissions(uiCode));
                this.sideBarPermissions = this.hasSidebarPermission ? rsp["SB"] : {};
                this.isOwner = false;
            }
        });
        this.$root.$on("maintenanceScheduled", () => {
            this.maintenanceSchedule = JSON.parse(localStorage.getItem("maintenanceSchedule"));
            this.maintenanceMessage = localStorage.getItem("maintenanceMessage");
        });
        this.$root.$on("invalidTenantCheck", () => {
            this.wrongTenant = true;
        })
        this.$root.$on("maintenanceStarted", () => {
            if (localStorage.getItem("maintenanceUser") !== "true") {
                $http({ url: "/auth/logout", type: "GET" }, true)
                    .then(() => {
                        window.location.href = "/";
                    })
                    .catch(() => {
                        window.location.href = "/";
                    });
            }
        });
        this.$root.$on("closeTaskInterface", () => {
            if (sessionStorage.getItem("submitClicked") === "true") {
                sessionStorage.removeItem("submitClicked");
            } else {
                this.$router.push("/taskNotAvailable");
            }
        });
        this.interfaceDirty = false;
        this.$backendWebsocketEvents.startWebsocket(this.taskId);
    },
    mounted() {
        // comm for now
        // this.$store.dispatch("tasks/getUserDetails");
        this.maintenanceSchedule = JSON.parse(localStorage.getItem("maintenanceSchedule"));
        this.maintenanceMessage = localStorage.getItem("maintenanceMessage");
        const wrongTenant = JSON.parse(localStorage.getItem("wrongTenantActive"));
        if (!wrongTenant) {
            this.setMultiLanguage(true);
        }
        const htmlView = document.getElementsByTagName("html")[0];
        addWindowResizeCallback({ fn: this.checkWindowSize, ctx: this }, true);
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.showLandscapeMsg = window.innerHeight < window.innerWidth;
        }
        if (this.isSmallScreen) {
            htmlView.style.position = "fixed";
        }
        window.addEventListener(
            "dragover",
            e => {
                e.preventDefault();
            },
            false
        );
        window.addEventListener(
            "drop",
            e => {
                e.preventDefault();
            },
            false
        );
        window.addEventListener("orientationchange", this.checkOrientation);

        const appPage = document.getElementsByClassName("page-container")[0];
        const uploadFields = document.getElementsByClassName("ctrl-upload");
        let dragCounter = 0;

        appPage.addEventListener("dragenter", () => {
            dragCounter++;
            for (let i = 0; i < uploadFields.length; i++) {
                uploadFields[i].classList.add("upload-focus-drag");
            }
        });
        appPage.addEventListener("dragleave", () => {
            dragCounter--;
            if (dragCounter === 0) {
                for (let i = 0; i < uploadFields.length; i++) {
                    uploadFields[i].classList.remove("upload-focus-drag");
                }
            }
        });
        appPage.addEventListener("drop", () => {
            dragCounter = 0;
            for (let i = 0; i < uploadFields.length; i++) {
                uploadFields[i].classList.remove("upload-focus-drag");
            }
        });

        this.$root.$on("openedComponent", (jumpToErrorData) => {
            this.openComponents(jumpToErrorData);
        });
    },
    updated() {
        // this.setMultiLanguage(false);
    },
    destroyed() {
        this.$root.$off("ui-render-interface");
        this.$root.$off("openedComponent");
        this.$root.$off("invalidTenantCheck");
    },
    beforeDestroy() {
        this.resetElementState();
        this.$store.commit("main/setCurrentApplicationId", "");
        this.$root.$off("closeTaskInterface");
        this.$root.$off("maintenanceScheduled");
        this.$root.$off("maintenanceStarted");
        window.removeEventListener("orientationchange", this.checkOrientation);
    },
    methods: {
        ...mapMutations("main", ["setCurrentApplicationId"]),
        ...mapMutations("components", [
            "setReadonly",
            "setProcessInstanceId",
            "setTaskId",
            "setActivityId",
            "updatePageReference",
            "setIsSmallScreen",
            "resetElementState",
            "updateLegacyElementState",
            "cleanResetId",
            "setWorkInProgress",
            "setAssistantForceOpen"
        ]),
        ...mapActions("components", [
            "claimTask",
            "guiSubmit",
            "getDataModelLatestVersion",
            "getInterfaceModel",
            "loadInterfaceData",
            "saveInterfaceData",
            "submitActions",
            "getAllEXternalApis"
        ]),
        ...mapActions("diagrams", ["getRedDotBoolean", "redDotProcessInstanceId"]),
        ...mapActions("main", ["getMultiFeaturesOption", "actBrandName"]),
        ...mapActions("apps", ["actGetCurrentAppUserPermissions", "actGetUserSystemPermissions"]),
        locationReplace() {
            let location;
            if (this.flow) {
                const getTeamGroupId = () => this.flow.groupId ? `&groupId=${this.flow.groupId}` : "";
                if (this.isSmallScreen && !this.isExternalTask) {
                    location = "/tasks/myTasks?tab=todo";
                } else if (this.flow.__teamDashboard) {
                    location = "/myteamsdashboard";
                } else if (this.flow.__dashboard || this.flow.__reports) {
                    location = "/mydashboard";
                } else if (this.flow.__tasks) {
                    location = "/tasks/myTasks?tab=todo";
                } else if (this.flow.__tasksCompleted) {
                    location = `/tasks/${this.flow.__teamsTasks ?
                            `teamTasks?tab=completed${getTeamGroupId()}` : "myTasks?tab=completed" }`;
                } else if (this.flow.__externalTaskComplete) {
                    location = "/external-task?completed=true";
                } else if (this.flow.__teamsTasks) {
                    location = `/tasks/teamTasks?tab=todo${getTeamGroupId()}`;
                } else {
                    location = "/mydashboard";
                }
            }
            return location;
        },
        setMultiLanguage(mounted) {
            this.getMultiFeaturesOption().then(data => {
                const multiLanguageObj = data.data.find(item => item.code === "ALLOW_MULTILANGUAGE");
                if (multiLanguageObj.enabled) {
                    if (this.userCookieInfo.language && mounted) {
                        if (localStorage.changedFlag === "true" && this.userCookieInfo.language !== localStorage.language) {
                            this.$i18n.locale = localStorage.language;
                        } else {
                            const lang = this.userCookieInfo.language;
                            this.$i18n.locale = lang;
                            localStorage.setItem("language", lang);
                        }
                    } else if (!mounted && this.userDataDetails.language && this.userDataDetails.language !== this.userCookieInfo.language) {
                        this.$i18n.locale = this.userDataDetails.language;
                        localStorage.setItem("language", this.userDataDetails.language);
                    }
                } else {
                    this.$i18n.locale = this.defaultLanguage;
                    localStorage.setItem("language", this.defaultLanguage);
                }
            });
        },
        openClosePrompt() {
            if (this.getAssistantForceOpen) {
                this.setAssistantForceOpen(false);
            } else {
                this.promptOpened = !this.promptOpened;
            }
        },
        footerAction(action) {
            if (action === "save") {
                this.onClickSave({ isSave: true }).catch(() => {});
            } else if (action === "submit") {
                this.modalSubmit = true;
            } else if (typeof action === "object") {
                if (action.trigger === "cancel") {
                    this.onClickCancel(action.ev);
                }
            }
        },
        fabAction(action) {
            switch (action) {
                case "documents":
                    this.modalDocuments = true;
                    break;
                case "timeline":
                    this.modalTimeline = true;
                    break;
                case "comments":
                    if (this.getHasNewComments && !this.readOnly) {
                        this.redDotProcessInstanceId(this.processInstanceId);
                        this.$store.commit("diagrams/setHasNewComments", false);
                    }
                    this.modalComments = true;
                    break;
                case "task":
                    this.modalInformation = true;
                    this.taskSelected = true;
                    break;
                case "errors":
                    this.rightDrawerOpen = true;
                    break;
                case "close":
                    this.rightDrawerOpen = false;
                    break;
            }
        },
        headerAction(action) {
            if (action.trigger === "cancel") {
                this.onClickCancel(action.ev);
            }
        },
        rightMenuAction(action) {
            if (action === "toggle") {
                this.miniRight = !this.miniRight;
            } else if (action === "flow") {
                this.footerMenu = true;
                this.$nextTick(() => {
                    this.appState = "flow";
                });
            } else if (action === "tracer") {
                this.footerMenu = false;
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.appState = "tracer";
                    });
                }, 200);
            } else if (action === "timeline") {
                this.modalTimeline = true;
            } else if (action === "documents") {
                this.modalDocuments = true;
            } else if (action === "comments") {
                if (this.getHasNewComments && !this.readOnly) {
                    this.redDotProcessInstanceId(this.processInstanceId);
                    this.$store.commit("diagrams/setHasNewComments", false);
                }
                this.modalComments = true;
            } else if (action === "information") {
                this.modalInformation = true;
                this.taskSelected = true;
            } else if (action === "errors") {
                this.modalErrors = true;
            }
        },
        customEvent(payload) {
            const { guid, event, error, params = {}, cbPromise = false } = payload;

            if (event === "onInput") {
                if (error) {
                    this.errorList.push(guid);
                } else if (this.errorList.includes(guid)) {
                    this.errorList = this.errorList.filter(elem => elem !== guid);
                }

                this.invalidInputData = !!this.errorList.length;
            } else if (event === "onClick" && cbPromise && (!Object.keys(params).length || params.hasMappedElems)) {
                if (this.validateInvalidFields(true)) {
                    this.__runEvent(guid, event, params, cbPromise);
                } else {
                    this.notifyErrorsFound();
                }
            } else {
                this.__runEvent(guid, event, params, cbPromise);
            }
        },
        doneRender() {
        },
        pageMounted() {
            this.updatePageReference(this.$refs.page.$el);
            if (this.loadedTheme) {
                this.__loadThemeObject(this.loadedTheme);
            }
            this.getRedDotBoolean(this.processInstanceId);
            this.interfaceDirty = false;
        },
        remoteCall(payload) {
            const callTypeMethods = {
                save: this.remoteSave,
                validate: this.remoteValidate
            };
            const { type, ...data } = payload;
            return callTypeMethods[type](data);
        },
        remoteSave(data) {
            const { resolve, reject, config } = data;
            const { prompt, silent } = Object.assign({ silent: false, prompt: true }, config);

            if (prompt) {
                this.$confirm("This action will save the interface data?", "Confirm", "Continue")
                    .then(() => this.onClickSave({ isSave: true, silent }).then(resolve, reject))
                    .catch(() => reject());
            } else {
                this.onClickSave({ isSave: true, silent }).then(resolve, reject);
            }
        },
        remoteValidate(data) {
            const { resolve, reject, config } = data;
            const { silent } = Object.assign({ silent: false }, config);

            const invalidFieldsCount = this.checkInvalidData(this.data).length;
            if (invalidFieldsCount) {
                if (!silent) {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$tc("fabricInterface.invalidFields", invalidFieldsCount),
                        code: "app-validationNOk",
                        timeout: 2000
                    });
                }
                reject();
            } else {
                resolve();
            }
        },
        customSave(resolve) {
            this.saveInterface().then(data => {
                resolve(data);
            });
        },
        namespaceDiffParser(guid, diffData, reverse = true) {
            const parseKeys = (dataObject, callback, parentKey, path = []) => {
                const localEvents = [];

                for (const [key, data] of Object.entries(dataObject)) {
                    const localPath = [...path];
                    let isNamespace = false,
                        parse = true;

                    if (key === "_id_") {
                        parse = false;
                    } else if (this.__isNumber(key)) {
                        localPath.push(key);
                        localEvents.push({
                            key,
                            data,
                            type: "index",
                            path: localPath,
                            parent: parentKey
                        });
                    } else {
                        isNamespace = guid === key || !!this.components[this.properties[key].__component].namespace;
                        if (isNamespace) {
                            localPath.push(key);
                            localEvents.push({
                                key,
                                data,
                                type: "namespace",
                                path: localPath,
                                parent: null
                            });
                        } else {
                            parse = false;
                            localPath.push(key, "value");
                            localEvents.push({
                                key,
                                data,
                                type: "input",
                                path: localPath,
                                parent: parentKey
                            });
                        }
                    }

                    if (parse && data) {
                        localEvents.push(...parseKeys(data, callback, key, localPath));
                    }
                }

                return localEvents;
            };

            return reverse ? parseKeys(diffData).reverse() : parseKeys(diffData);
        },
        namespaceInitParser(guid, diffData, value) {
            const guidList = [];
            const events = this.namespaceDiffParser(guid, diffData, false);

            events.forEach(event => {
                if (event.type === "input") {
                    const parentPath = [...event.path];
                    parentPath.splice(-2);

                    guidList.push(event.key);
                    this.__executeInitScriptChildInput({
                        guid: event.key,
                        index: parseInt(parentPath.slice(-1)[0], 10),
                        value: _get(value, event.path),
                        path: parentPath
                    });
                } else if (event.type === "index") {
                    this.__executeInitScriptChild(
                        {
                            guid: event.parent,
                            index: parseInt(event.key, 10),
                            value: _get(value, event.path),
                            path: event.path
                        },
                        true
                    );
                } else {
                    const index = event.path.length > 2 ? event.path.slice(-2)[0] : -1;
                    guidList.push(event.key);
                    this.__executeInitScriptChild({
                        guid: event.key,
                        index,
                        value: _get(value, event.path),
                        path: event.path
                    });
                }
            });

            return guidList;
        },
        namespaceChangeParser(guid, diffData, prmValue, prmOldValue) {
            const events = this.namespaceDiffParser(guid, diffData);
            const triggers = [...new Set(events.filter(event => event.type === "input").map(event => event.key))];

            events.forEach((event, idx) => {
                const newValue = _get(prmValue, event.path);
                const oldValue = _get(prmOldValue, event.path);

                if (event.type === "input") {
                    const parentPath = [...event.path];
                    parentPath.splice(-2);

                    this.__runNamespaceChangeEventInput({
                        newValue,
                        oldValue,
                        guid: event.key,
                        index: parseInt(parentPath.slice(-1)[0], 10),
                        path: parentPath
                    });
                } else if (event.type === "index") {
                    this.__runNamespaceChangeEvent(
                        {
                            newValue,
                            oldValue,
                            triggers,
                            guid: event.parent,
                            index: parseInt(event.key, 10),
                            path: event.path
                        },
                        true
                    );
                } else {
                    this.__runNamespaceChangeEvent({
                        newValue,
                        oldValue,
                        triggers,
                        guid: event.key,
                        index: parseInt(events[idx - 1].key, 10),
                        path: event.path
                    });
                }
            });
        },
        flattenObject(obj) {
            const flatResult = {};

            for (let [objKey, objData] of Object.entries(obj || {})) {
                if (["value", "text"].includes(objKey) || !objData) {
                    flatResult[objKey] = objData;
                } else if (objData) {
                    if (objData.constructor === Array) {
                        const objectArray = {};
                        objData.forEach((data, idx) => (objectArray[idx] = data));
                        objData = objectArray;
                    }

                    if (objData.constructor === Object) {
                        const flatObject = this.flattenObject(objData);
                        for (const [flatKey, flatData] of Object.entries(flatObject)) {
                            flatResult[objKey + "." + flatKey] = flatData;
                        }
                    }
                }
            }

            return flatResult;
        },
        changeHandler(value) {
            const newOldData = structuredClone(value);

            if (this.oldTemplateData) {
                if (this.resetId.length) {
                    this.resetId.forEach(pathEntry => {
                        _set(this.oldTemplateData, pathEntry.split("."), []);
                    });
                }

                const lhs = cleanKeys(this.oldTemplateData, ["errorState", "forceError"]);
                const rhs = cleanKeys(newOldData, ["errorState", "forceError"])

                // const differences = detailedDiff(this.oldTemplateData, newOldData);
                const differences = detailedDiff(lhs, rhs);
                const { added, deleted, updated } = differences;

                if (Object.keys(added).length || Object.keys(deleted).length || Object.keys(updated).length) {
                    const diffSignature = JSON.stringify(differences) + "|" + JSON.stringify(newOldData);

                    if (this.lastDiffSignature === diffSignature && !this.resetId.length) {
                        return;
                    }

                    const changed = [];
                    const flatDiffs = this.flattenObject(differences);
                    const cleanDiffs = {};

                    this.lastDiffSignature = diffSignature;
                    for (const [key, data] of Object.entries(flatDiffs)) {
                        const path = key.split(".");
                        const [lastComponent, dataAttribute] = path.slice(-2);

                        if (dataAttribute !== "text") {
                            if (path[0] === "added") {
                                const properties = this.properties[lastComponent];
                                const config = this.components[properties.__component];

                                if (config.componentName === "ctrl-mselect" && data && data.constructor === Object) {
                                    path[0] = "updated";
                                }
                            }

                            _setWith(cleanDiffs, path, data, Object);
                        }
                    }

                    this.cleanResetId();
                    Object.entries(cleanDiffs).forEach(([key, diffData]) => {
                        if (key === "deleted") {
                            this.doDeleteChanges(diffData, value, changed);
                        } else if (key === "added") {
                            this.doAddChanges(diffData, value, changed);
                        } else if (key === "updated") {
                            this.doUpdateChanges(diffData, value, changed);
                        }
                    });
                }
            }

            this.oldTemplateData = newOldData;
        },
        doAddChanges(diffData, value, changed) {
            Object.keys(diffData).forEach(guid => {
                const properties = this.properties[guid];
                const config = this.components[properties.__component];

                if (config.namespace) {
                    const oldTemplateDataClone = structuredClone(this.oldTemplateData);
                    this.$nextTick(() => {
                        this.namespaceAddParser(guid, { [guid]: diffData[guid] }, value, oldTemplateDataClone);
                    });
                } else if (!changed.includes(guid)) {
                    const oldValue = this.oldTemplateData.hasOwnProperty(guid) ? this.oldTemplateData[guid].value : undefined;
                    const newValue = value.hasOwnProperty(guid) ? value[guid].value : undefined;

                    changed.push(guid);
                    this.$nextTick(() => {
                        this.__runChangeEvent(guid, newValue, oldValue);
                    });
                }
            });
        },
        doUpdateChanges(diffData, value, changed) {
            Object.keys(diffData).forEach(guid => {
                const properties = this.properties[guid];
                const config = this.components[properties.__component];

                if (config.namespace) {
                    const oldTemplateDataClone = structuredClone(this.oldTemplateData);
                    this.$nextTick(() => {
                        this.namespaceChangeParser(guid, { [guid]: diffData[guid] }, value, oldTemplateDataClone);
                    });
                } else if (Object.keys(diffData[guid]).includes("value") && !changed.includes(guid)) {
                    const oldValue = this.oldTemplateData.hasOwnProperty(guid) ? this.oldTemplateData[guid].value : undefined;
                    const newValue = value.hasOwnProperty(guid) ? value[guid].value : undefined;

                    changed.push(guid);
                    this.$nextTick(() => {
                        this.__runChangeEvent(guid, newValue, oldValue);
                    });
                }
            });
        },
        doDeleteChanges(diffData, value, changed) {
            Object.keys(diffData).forEach(guid => {
                const properties = this.properties[guid];
                const config = this.components[properties.__component];

                if (config.namespace) {
                    const oldTemplateDataClone = structuredClone(this.oldTemplateData);
                    this.$nextTick(() => {
                        this.namespaceChangeParser(guid, { [guid]: diffData[guid] }, value, oldTemplateDataClone);
                    });
                } else if (!changed.includes(guid)) {
                    const oldValue = this.oldTemplateData.hasOwnProperty(guid) ? this.oldTemplateData[guid].value : undefined;
                    const newValue = value.hasOwnProperty(guid) ? value[guid].value : undefined;

                    changed.push(guid);
                    this.$nextTick(() => {
                        this.__runChangeEvent(guid, newValue, oldValue);
                    });
                }
            });
        },
        saveInterface(isSave) {
            return this.$refs.page.saveRichTexts().then(() => {
                const data = this.packData();
                const saveData = {
                    processInstanceId: this.flow.processInstanceId,
                    guid: this.flow.guiId,
                    activityId: this.activityId,
                    taskId: this.taskId,
                    data,
                    isSaveForLater: isSave
                };

                return this.saveInterfaceData(saveData);
            });
        },
        checkMandatory() {
            const mandatoryList = [];
            const isFunction = object => !!(object && object.constructor && object.call && object.apply);

            Object.entries(this.legacyElementState).forEach(([key, value]) => {
                const { mandatory, display } = value || {};

                if (mandatory && display) {
                    const path = key.split(",");
                    const entryKey = path.slice(-1);
                    const properties = this.properties[entryKey];
                    const config = this.components[properties.__component];
                    const { fn = {} } = config;
                    const noPath = { undefined: null };
                    const valueData = _get(this.data, [...path, "value"], noPath);
                    let notCompleted;

                    if (valueData !== noPath) {
                        if (fn.hasOwnProperty("checkMandatory") && isFunction(fn.checkMandatory)) {
                            notCompleted = !fn.checkMandatory(valueData, properties);
                        } else {
                            notCompleted = valueData === null || valueData === undefined || valueData === "" || valueData === "[]";
                        }
                    }

                    if (notCompleted) {
                        mandatoryList.push(key);
                    }
                }
            });

            return mandatoryList;
        },
        getMapType(properties) {
            const { set } = properties;
            let type;

            if (set && set.startsWith("m_")) {
                const pathList = set.substring(2).split(".");

                if (pathList.length > 1) {
                    let cursor = this.parsed.modelClasses[pathList.splice(0, 1)[0]];

                    pathList.forEach(node => (cursor = cursor && cursor.fields ? cursor.fields[node] : null));
                    if (cursor) {
                        type = this.$lowerCase(cursor.type);
                    }
                }
            }

            return type || null;
        },
        checkLengthRange(validations, val, fromNumber) {
            let isError = false;
            const { minLengthValue, maxLengthValue} = validations;
            const valToCheck = fromNumber ? Number(val) : val.toString().length;
            if (minLengthValue > maxLengthValue || maxLengthValue < minLengthValue) {
                isError = true;
            } else if (minLengthValue && maxLengthValue === undefined) {
                isError = valToCheck < Number(minLengthValue);
            } else if (minLengthValue === undefined && maxLengthValue) {
                isError = valToCheck > Number(maxLengthValue);
            } else if (minLengthValue !== undefined && maxLengthValue !== undefined) {
                isError = !(valToCheck >= Number(minLengthValue) && valToCheck <= Number(maxLengthValue))
            }
            return isError;
        },
        checkInvalidData(data, path, index, basePath) {
            const invalidComponents = [];

            for (const [key, value] of Object.entries(data)) {
                let found = false;
                let found2 = false;
                if (key === "_id_") { continue; }

                if (value.constructor === Object) {

                    if (Object.keys(value).includes("value")) {
                        const props = this.properties[key];
                        const { __component: type, set } = props;
                        const { value: val } = value;

                        if (type === "ctrl-textbox") {
                            let tempError = false;
                            if (set) {
                                const mapType = this.getMapType(props);
                                if (mapType === "integer" || mapType === "decimal") {
                                    const validateFn = mapType === "integer" ? integer : decimal;
                                // const isValid = validateFn(val) && parseFloat(val || "0") < 2147483647;
                                    const isValid = validateFn(val);
                                    if (isValid) {
                                        if (val) {
                                            const parseFn = mapType === "integer" ? parseInt : parseFloat;
                                            value["value"] = parseFn(val);
                                        }
                                    } else {
                                        const { currentErrorMsg } = props.__validations;
                                        found = true;
                                        invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: currentErrorMsg });
                                    }
                                }
                            }
                            if (props.__validations) {
                                const { errorState } = value;
                                const { excludeSpCharacters, excludeNumbers, lengthState,
                                    validationType, intOrDecimalVal, nrDecimals, regexExpression, currentErrorMsg } = props.__validations;
                                if (errorState && !found) {
                                    invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: currentErrorMsg });
                                } else if (validationType === "text" && val && !found) {
                                    const regexExcludeSpChar = /^[a-zA-Z0-9]*$/;
                                    const regexExcludeNumbers = /^[^0-9]*$/;
                                    let tempError2 = false;
                                    if (excludeSpCharacters) {
                                        tempError2 = !regexExcludeSpChar.test(val);
                                    }
                                    if (excludeNumbers && !tempError2) {
                                        tempError2 = !regexExcludeNumbers.test(val);
                                    }
                                    if (lengthState && !tempError2) {
                                        tempError2 = this.checkLengthRange(this.properties[key].__validations, val);
                                    }
                                    if (this.data[basePath] && this.data[basePath].length) {
                                        this.data[basePath][index][key].errorState = tempError2;
                                        found2 = this.data[basePath][index][key].errorState;
                                    } else if (this.data[key]) {
                                        this.data[key].errorState = tempError;
                                        found2 = this.data[key].errorState;
                                    }
                                    if (found2) {invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: currentErrorMsg });}
                                } else if (validationType === "number" && val && !found) {
                                    const validateFn = intOrDecimalVal === "integer" ? integer : decimal;
                                    tempError = !validateFn(val) || isNaN(val);
                                    if (intOrDecimalVal === "decimal" && !tempError && val.toString().includes(".") && nrDecimals) {
                                        tempError = val.toString().split(".")[1].length > nrDecimals;
                                    }
                                    if (lengthState && !tempError) {
                                        tempError = this.checkLengthRange(this.properties[key].__validations, val, true);
                                    }
                                    if (this.data[basePath] && this.data[basePath].length) {
                                        this.data[basePath][index][key].errorState = tempError;
                                    } else {
                                        this.data[key].errorState = tempError;
                                    }
                                    if (tempError) {invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: currentErrorMsg });}
                                } else if (validationType === "other" && val && !found) {
                                    let formattedRegex = "";
                                    tempError = false;
                                    let isValidRegEx = this.isRegexValid(regexExpression);
                                    if (isValidRegEx) {
                                        formattedRegex = new RegExp(regexExpression);
                                    }
                                    if (this.data[basePath] && this.data[basePath].length) {
                                        this.data[basePath][index][key].errorState = isValidRegEx ? !formattedRegex.test(val) : true;
                                        tempError = this.data[basePath][index][key].errorState;
                                    } else {
                                        this.data[key].errorState = isValidRegEx ? !formattedRegex.test(val) : true;
                                        tempError = this.data[key].errorState;
                                    }
                                    if (tempError) {invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: currentErrorMsg });}
                                }
                            }
                            if (value.hasOwnProperty("forceError") && value.forceError && !value.errorState && !found && !found2 && !tempError) {
                                invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: value.customErrMsg });
                            }
                        } else if (type === "ctrl-textarea" && props.__validations) {
                            const { lengthState, currentErrorMsg } = props.__validations;
                            const { errorState } = value;
                            let tempError = false;
                            if (errorState) {
                                invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: currentErrorMsg });
                            } else if (lengthState && val && !errorState) {
                                if (this.data[basePath] && this.data[basePath].length) {
                                    this.data[basePath][index][key].errorState = this.checkLengthRange(this.properties[key].__validations, val);
                                    tempError = this.data[basePath][index][key].errorState;
                                } else {
                                    this.data[key].errorState = this.checkLengthRange(this.properties[key].__validations, val);
                                    tempError = this.data[key].errorState;
                                }
                                if (tempError) {invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: currentErrorMsg });}
                            }
                            if (value.hasOwnProperty("forceError") && value.forceError && !tempError && !errorState) {
                                invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: value.customErrMsg });
                            }
                        } else if (this.elementsListCheckError.includes(type) && value.forceError) {
                            invalidComponents.push({key, path: path ? `${path},${key}` : key, errorMsg: value.customErrMsg });
                        }
                    } else {
                        invalidComponents.push(...this.checkInvalidData(value));
                    }
                } else if (value.constructor === Array) {
                    value.forEach((entry, index) => {
                        const compPath = path ? `${path},${key},${index}` : `${key},${index}`;
                        invalidComponents.push(...this.checkInvalidData(entry, compPath, index, key));
                    })
                }
            }

            return invalidComponents;
        },
        isRegexValid(regexStr) {
            try {
              new RegExp(regexStr);
              return true;
            } catch (e) {
              return false;
            }
        },
        validateInvalidFields(fromSave) {
            this.invalidFields = this.checkInvalidData(this.data);
            let validation = true;
            if (this.invalidFields.length) {
                validation = false;
                if (fromSave) {
                    this.notifyErrorsFound();
                }
            }
            return validation;
        },
        onClickSave({ isSave, actionLabel, silent }) {
            return new Promise((resolve, reject) => {
                const saveFn = () => {
                    this.saveInterface(isSave).then(response => {
                        if (response) {
                            if (isSave && !silent && this.validateInvalidFields(isSave)) {
                                this.$toast.showNotify({
                                    type: "success",
                                    message: this.$t("userInterface.saveInterface"),
                                    code: "app-saveOk",
                                    timeout: 2000
                                });
                            }
                            resolve();
                        } else {
                            if (isSave && !silent) {
                                this.$toast.showNotify({
                                    type: "error",
                                    message: "There was a problem while saving the interface data",
                                    code: "app-saveNOk",
                                    timeout: 2000
                                });
                            }
                            reject({ check: true, save: false });
                        }
                    });
                };

                const createPathForError = () => {
                    this.invalidFields.forEach(obj => {
                        const path = obj.path.split(",");
                        if (path.length > 1) {
                            const objCreated = this.reverseCreateObjectFromPath(path, obj.path);
                            obj.localPath = objCreated;
                        } else {
                            [obj.localPath] = path;
                        }
                    });
                }
                this.$store.commit("components/setErrorsClicked", []);

                if (isSave) {
                    this.interfaceDirty = false;
                    this.__runSaveEvents(false).then(save => {
                        if(save) {
                            this.invalidFields = this.checkInvalidData(this.data);
                            if (this.invalidFields.length) {
                                createPathForError();
                                this.notifyErrorsFound();
                            } else {
                                save && saveFn();
                            }
                        }
                    });
                } else {
                    const validateErrors = () => {
                        const mandatoryIssues = this.checkMandatory();
                        const mandatoryErrors = [];
                        if (mandatoryIssues.length) {
                            mandatoryIssues.forEach(mandatoryIssue => {
                                const path = mandatoryIssue.split(",");
                                if (path.length > 1) {
                                    const obj = this.reverseCreateObjectFromPath(path, mandatoryIssue);
                                    mandatoryErrors.push(obj);
                                } else {
                                    mandatoryErrors.push(path[0]);
                                }
                            });
                        }
                        const issues = mandatoryIssues.length;
                        this.invalidFields = this.checkInvalidData(this.data);
                        if (this.invalidFields.length) {
                            createPathForError();
                        }

                        if (issues) {
                            this.invalidFields = this.invalidFields.concat(mandatoryErrors);
                        }

                        let validation = true;

                        if (issues || this.invalidFields.length) {
                            mandatoryIssues.forEach(guid => {
                                this.updateLegacyElementState({ guid, values: { mandatoryShow: true } });
                            });
                            validation = false;
                            this.notifyErrorsFound();
                        }
                        return validation;
                    };

                    this.__runSubmitEvents(actionLabel).then(submit => {
                        if (submit) {
                            if (validateErrors()) {
                                this.__runSaveEvents(true, actionLabel).then(save => {
                                    if (save && this.validateInvalidFields()) {
                                        save && saveFn()
                                    } else if (this.invalidFields.length) {
                                        createPathForError();
                                        this.notifyErrorsFound();
                                    }
                                });
                            } else {
                                reject({ check: false, save: false });
                            }
                        }
                    });
                }
            });
        },
        onEventSubmit(targetId, commentText) {
            sessionStorage.setItem("submitClicked", true);
            this.onClickSave({
                isSave: false,
                actionLabel: targetId ? this.submitActionsList.find(el => el.value === targetId).label : this.submitActionsList[0].label
            }).then(() => {
                    this.guiSubmit({
                        actionId: targetId || this.submitActionsList[0].value,
                        comment: commentText,
                        taskId: this.taskId,
                        taskType: this.taskType
                    })
                        .then(() => {
                            localStorage.removeItem("executionData");
                            const locationToGoBack = this.locationReplace();
                            if (locationToGoBack) {
                                if (this.flow.__externalTaskComplete) {
                                    window.location.replace(locationToGoBack);
                                } else {
                                    this.$router.push({ path: locationToGoBack }).then(
                                        () => {
                                            if (this.$backendDrivenEvents.state.refreshTasks) {
                                                this.$backendDrivenEvents.state.refreshTasks = false;
                                            }
                                        }
                                    );
                                }
                            }
                        })
                        .catch(() => this.notifySubmitError());
                })
                .catch(data => {
                    if (data.check && !data.save) {
                        this.notifySubmitError();
                    }
                    sessionStorage.removeItem("submitClicked");
                });
        },
        onClickCancel(event) {
            if (event.altKey && event.ctrlKey && event.shiftKey) {
                this.showDebug = !this.showDebug;
            } else if (this.isReadOnly) {
                if (this.isFromPLV) {
                    window.close();
                } else {
                    const locationToGoBack = this.locationReplace();
                    if (locationToGoBack) {
                        this.$router.push({ path: locationToGoBack });
                    }
                }
            } else {
                if (this.interfaceDirty) {
                    this.goBack = true;
                } else {
                    this.confirmGoBack();
                }
            }
        },
        notifySubmitError() {
            this.$toast.showNotify({
                type: "error",
                message: "There was a problem while submitting the interface",
                code: "app-submitNOk",
                timeout: 2000
            });
        },
        unpackData() {
            const parseData = (dataModel, source, startPath = "") => {
                Object.entries(dataModel).forEach(([key, data]) => {
                    if (key !== "_id_") {
                        const properties = this.properties[key];

                        if (properties.get) {
                            if (data.constructor === Array) {
                                const values = this.__getPathValue(source, properties.get, startPath).data;

                                if (values && values.length) {
                                    const emptyBody = this.__generateData(this.bodyReference[key], 0);
                                    dataModel[key] = Array(values.length)
                                        .fill("")
                                        .map((val, idx) => extend(true, { _id_: values[idx]._id_ }, emptyBody));
                                    for (let loop = 0; loop < values.length; loop++) {
                                        parseData(dataModel[key][loop], values[loop], properties.get);
                                    }
                                } else {
                                    const emptyBody = this.__generateData(this.bodyReference[key], 1);
                                    dataModel[key] = [structuredClone(emptyBody)];
                                }
                            } else {
                                const configProperties = this.components[properties.__component];

                                if (configProperties.componentName === "ctrl-data-table") {
                                    const loadedData = this.__getPathValue(source, properties.get, startPath).data;

                                    if (loadedData) {
                                        const colPairs = {};
                                        const tableData = [];

                                        properties.columns.forEach(({ field, get }) => {
                                            if (get) {
                                                colPairs[get.replace(`${properties.set}.`, "")] = field;
                                            }
                                        });

                                        loadedData.forEach(entry => {
                                            const row = {};
                                            Object.keys(entry).forEach(key => {
                                                const pair = key === "_id_" ? key : colPairs[key];
                                                if (pair) {
                                                    row[pair] = entry[key];
                                                }
                                            });
                                            tableData.push(row);
                                        });

                                        dataModel[key].value = tableData;
                                    } else {
                                        dataModel[key].value = null;
                                    }
                                } else {
                                    const { data, found } = this.__getPathValue(source, properties.get, startPath);
                                    if (found) {
                                        dataModel[key].value = data;
                                    } else {
                                        const { fn = {} } = configProperties;
                                        if (fn.hasOwnProperty("initValue") && typeof fn.initValue === "function") {
                                            dataModel[key].value = fn.initValue(properties);
                                        } else {
                                            dataModel[key].value = null;
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            };
            parseData(this.data, this.loadedData);
        },
        packData() {
            const parseData = (interfaceData, saveModel, startPath = "") => {
                Object.entries(interfaceData).forEach(([key, data]) => {
                    if (key === "_id_") {
                        saveModel._id_ = data;
                    } else {
                        const properties = this.properties[key];
                        const configProperties = this.components[properties.__component];

                        if (properties.set) {
                            if (data.constructor === Array) {
                                const arrayData = [];
                                data.forEach(entry => {
                                    arrayData.push(parseData(entry, {}, properties.set));
                                });
                                this.__addPathValue(saveModel, properties.set, arrayData, startPath);
                            } else if (configProperties.componentName === "ctrl-data-table") {
                                let tableData = null;

                                if (data.value) {
                                    const colPairs = {};

                                    tableData = [];
                                    properties.columns.forEach(({ field, get }) => {
                                        if (get) {
                                            colPairs[field] = get.replace(`${properties.set}.`, "");
                                        }
                                    });

                                    data.value.forEach(entry => {
                                        const row = {};
                                        Object.keys(entry).forEach(key => {
                                            if (key === "_id_") {
                                                row[key] = entry[key];
                                            } else if (colPairs.hasOwnProperty((key))) {
                                                row[colPairs[key]] = entry[key];
                                            }
                                        });
                                        tableData.push(row);
                                    });
                                }

                                this.__addPathValue(saveModel, properties.set, tableData, startPath);
                            } else {
                                let allGood = true;

                                if (configProperties.hasOwnProperty("generator") && configProperties.generator) {
                                    allGood = !!data.value;
                                }

                                if (allGood) {
                                    this.__addPathValue(saveModel, properties.set, data.value, startPath);
                                }
                            }
                        }
                    }
                });

                return saveModel;
            };

            return parseData(this.data, {});
        },
        parseComponents(components) {
            return new Promise(resolve => {
                Object.entries(components).forEach(([guid, properties]) => {
                    this.__checkEventsStuff(guid, properties);
                    this.__checkCatalogStuff(guid, properties);
                });

                resolve();
            });
        },
        setComponentsActions(components) {
            return new Promise(resolve => {
                this.parseComponents(components).then(() => {
                    this.__loadCatalogs().then(() => {
                        resolve();
                    });
                });
            });
        },
        updateSubmitActions(actions) {
            const actionDetails = {};
            const actionList = [];

             if (this.isApprovalTask) {
                actions.forEach(action => {
                    const { actionCode, actionName, preselectedTarget, submissionOption, submissionOrder } = action;
                    actionDetails[actionCode] = action;
                    if (action.activityType === "GENERAL_END_PLUGIN") {
                        actionList.push({
                            rightIcon: { name: "fiber_manual_record", color: "#D15656", size: "16px" },
                            label: actionName,
                            value: actionCode,
                            preselectedTarget: preselectedTarget,
                            submissionOption: submissionOption,
                            submissionOrder: submissionOrder
                        });
                    } else {
                        actionList.push({
                            label: actionName,
                            value: actionCode,
                            preselectedTarget: preselectedTarget,
                            submissionOption: submissionOption,
                            submissionOrder: submissionOrder
                        });
                    }
                });
            } else {
                actions.forEach(action => {
                    const { actionId, actionName, preselectedTarget, submissionOption, submissionOrder } = action;
                    actionDetails[actionId] = action;
                    if (action.activityType === "GENERAL_END_PLUGIN") {
                        actionList.push({
                            rightIcon: { name: "fiber_manual_record", color: "#D15656", size: "16px" },
                            label: actionName,
                            value: actionId,
                            preselectedTarget: preselectedTarget,
                            submissionOption: submissionOption,
                            submissionOrder: submissionOrder
                        });
                    } else {
                        actionList.push({
                            label: actionName,
                            value: actionId,
                            preselectedTarget: preselectedTarget,
                            submissionOption: submissionOption,
                            submissionOrder: submissionOrder
                        });
                    }
                });
            }

            this.actionDetails = actionDetails;
            this.submitActionsList = actionList;
        },
        starInterfaceLoad() {
            const execData = this.flow;
            this.$store.state.components.events = {};

            if (!execData.perspectiveId) {
                this.submitActions(this.flow.activityId).then(actions => {
                    let filteredActions = [];
                    for (let i=0;i<actions.length;i++) {
                        filteredActions.push({actionId: actions[i].actionId, label: actions[i].actionName})
                    }
                    this.$store.commit("components/setSubmitActionsList", filteredActions);
                    this.updateSubmitActions(actions);
                });
            }

            this.__loadComponents().then(() => {
                this.getDataModelLatestVersion().then(() => {
                    const { processInstanceId, guiId: guid } = this.flow;
                    const loadInterfaceObj = {
                        processInstanceId,
                        perspectiveId: execData.perspectiveId,
                        appId: execData.applicationId,
                        guid,
                        plv: this.isFromPLV,
                        activityId: this.flow.activityId
                    };
                    const interfaceData = this.loadInterfaceData(loadInterfaceObj);

                    const interfaceModel = this.getInterfaceModel({ guiId: guid, fromStart: true, update: true });
                    const integrationAPIs = this.getAllEXternalApis(execData.applicationId);
                    const dataModel = new Promise(resolve => {
                        this.getRawDataModel(true).then(() => {
                            this.parseCatalogsRawData();
                            this.parseModelClassesRawData();
                            resolve();
                        });
                    });

                    Promise.all([interfaceData, interfaceModel, integrationAPIs, dataModel]).then(([iData, iModel, apis]) => {
                        const interfaceModel = (iModel.model && iModel.model.interfaceJson) || { components: {}, body: [] };
                        this.loadedData = iData;
                        if (interfaceModel.hasOwnProperty("config") && interfaceModel.config.hasOwnProperty("theme")) {
                            this.loadedTheme = interfaceModel.config.theme;
                        }

                        this.parseAPIsRawData(apis).then(() => {
                            const aggComponents = { ...interfaceModel.components };
                            const fragments = (interfaceModel.config && interfaceModel.config.fragments) || [];

                            fragments.forEach(fragment => {
                                if (this.fragments[fragment]) {
                                    const { components } = this.fragments[fragment].interfaceJson;
                                    Object.keys(components).forEach(key => aggComponents[key] = components[key]);
                                }
                            });

                            this.setComponentsActions(aggComponents).then(() => {
                                this.__loadInterfaceFromJSON(interfaceModel);
                                this.$nextTick(() => {
                                    this.setWorkInProgress(false);
                                    this.loading = false;
                                    if (this.isReadOnly) {
                                        this.$toast.showNotify({
                                            type: "info",
                                            message: this.$t("userInterface.viewMode"),
                                            code: "app-openRO",
                                            timeout: 2000
                                        });
                                    }
                                });
                            });
                        });
                    });
                });
            });

            this.$root.$on("ui-render-interface", () => {
                this.templateFragment = this.body;
                this.setData(this.__generateData(this.body, 0));
                this.unpackData();

                this.__initStateFromData(this.data);
                console.log("__runInitEvents");
                const ignoreList = this.checkInitEvents();

                this.__runInitEvents(ignoreList).then(() => {
                    this.templateData = this.data;
                });
            });
        },
        checkInitEvents() {
            const initDifferences = detailedDiff({}, this.data);
            const guidList = [];

            Object.keys(initDifferences.added).forEach(guid => {
                const properties = this.properties[guid];
                const config = this.components[properties.__component];

                if (config.namespace) {
                    guidList.push(...this.namespaceInitParser(guid, { [guid]: initDifferences.added[guid] }, this.data));
                }
            });

            return guidList;
        },
        namespaceAddParser(guid, diffData, values, oldValues) {
            const { events, trigger } = this.parseAddedData(guid, diffData, oldValues);

            events.forEach((event, idx) => {
                const { type, init, change, path, guid } = event;

                if (type === "namespace") {
                    if (change) {
                        const newValue = _get(values, path);
                        const oldValue = _get(oldValues, path);

                        this.__runNamespaceChangeEvent({
                            newValue,
                            oldValue,
                            triggers: [trigger],
                            guid,
                            index: parseInt(events[idx + 1].index, 10),
                            path
                        });
                    } else if (init) {
                        const index = path.length > 2 ? parseInt(path.slice(-2)[0], 10) : -1;
                        this.__executeInitScriptChild({ guid, index, value: _get(values, path), path });
                    }
                } else {
                    const { fields = [] } = event;

                    if (change) {
                        const { type } = event;
                        const index = type === "index" ? event.index : events[idx + 1].index;
                        const newValue = _get(values, path);
                        const oldValue = _get(oldValues, path);

                        this.__runNamespaceChangeEvent(
                            {
                                newValue,
                                oldValue,
                                triggers: [trigger],
                                guid,
                                index: parseInt(index, 10),
                                path
                            },
                            true
                        );
                        fields.forEach(field => {
                            const { path, key } = field;
                            const newValue = _get(values, path);
                            const oldValue = _get(oldValues, path);
                            const parentPath = [...path];
                            parentPath.splice(-2);

                            this.__runNamespaceChangeEventInput({
                                newValue,
                                oldValue,
                                guid: key,
                                index: parseInt(parentPath.slice(-1)[0], 10),
                                path: parentPath
                            });
                        });
                    } else if (init) {
                        this.__executeInitScriptChild(
                            {
                                guid,
                                index: parseInt(path.slice(-1)[0], 10),
                                value: _get(values, path),
                                path
                            },
                            true
                        );
                        fields.forEach(field => {
                            const { path, key } = field;
                            const parentPath = [...path];
                            parentPath.splice(-2);

                            this.__executeInitScriptChildInput({
                                guid: key,
                                index: parseInt(parentPath.slice(-1)[0], 10),
                                value: _get(values, path),
                                path: parentPath
                            });
                        });
                    }
                }
            });
        },
        parseAddedData(guid, addedData, oldData) {
            const fields = {};
            const parseKeys = (dataObject, parentKey, path = []) => {
                const addedTree = [];

                for (const [key, data] of Object.entries(dataObject)) {
                    const localPath = [...path];
                    let parse = true;

                    if (this.__isNumber(key)) {
                        localPath.push(key);
                        addedTree.push({
                            type: "index",
                            index: parseInt(key, 10),
                            guid: parentKey,
                            path: localPath
                        });
                    } else {
                        const isNamespace = guid === key || !!this.components[this.properties[key].__component].namespace;
                        if (isNamespace) {
                            localPath.push(key);
                            addedTree.push({ type: "namespace", guid: key, path: localPath });
                        } else {
                            const stringPath = localPath.join(".");
                            if (!fields.hasOwnProperty(stringPath)) {
                                fields[stringPath] = [];
                            }

                            fields[stringPath].push({ key, data, path: [...localPath, key, "value"] });
                            parse = false;
                        }
                    }

                    if (parse) {
                        addedTree.push(...parseKeys(data, key, localPath));
                    }
                }

                return addedTree;
            };

            let events = void 0;
            let trigger = void 0;
            let foundTrigger = false;

            events = parseKeys(addedData)
                .reverse()
                .map(entry => {
                    const was = _has(oldData, entry.path);
                    const out = { ...entry, init: !was, change: was };
                    const { type } = entry;

                    if (type === "index") {
                        const { path, index } = entry;
                        const strPath = path.join(".");

                        out.fields = fields[strPath];
                        if (!foundTrigger && !was) {
                            foundTrigger = true;
                            trigger = entry.guid;
                        }
                    }

                    return out;
                })
                .reverse();

            return { events, trigger };
        },
        unclaimMessageEvent() {
            if (this.flow.__reports) {
                this.actionMessage = this.$t("tasks.unclaimMessage");
                this.showActionMessage = true;
            }
        },
        reassignMessageEvent() {
            if (this.flow.__reports) {
                this.actionMessage = this.$t("tasks.reassignMessage");
                this.showActionMessage = true;
            }
        },
        locationReplaceEvent() {
            const locationToGoBack = this.locationReplace();
            if (locationToGoBack && !this.flow.__reports) {
                this.$router.push({ path: this.locationToGoBack });
            }
        },
        checkWindowSize(size = window.innerWidth) {
            if (size < this.$q.screen.sizes.sm) {
                if (!this.isSmallScreen) {
                    this.setIsSmallScreen(true);
                }
            } else if (this.isSmallScreen) {
                this.setIsSmallScreen(false);
            }
        },
        checkOrientation() {
            if (navigator.userAgent.match("CriOS")) {
                this.showLandscapeMsg =
                    window.innerHeight < window.innerWidth || (window.innerHeight > window.innerWidth && window.innerWidth / window.innerHeight < 9 / 13);
            } else {
                this.showLandscapeMsg =
                    window.innerHeight > window.innerWidth || (window.innerHeight < window.innerWidth && window.innerHeight / window.innerWidth > 9 / 13);
            }
        },
        confirmGoBack() {
            this.interfaceDirty = false;
            this.$router.push({ path: this.locationReplace() });
        },

        openComponents(objResult, main) {
            const { componentType, componentCode, componentIndex } = objResult;
            let newPath;
            if (main || objResult.customPath) {
                const restPath = `${componentCode}${componentIndex ? ',' + componentIndex : ""}`;
                newPath = typeof main === "boolean" ? restPath : `${main || objResult.customPath},${restPath}`;
            }
            if (Number.isInteger(objResult.indexInList)) {
                if (objResult.child) {
                    objResult.child.indexInList = objResult.indexInList;
                }
            }
            if (
                objResult.componentType !== "ctrl-panel" && objResult.componentType !== "ctrl-section"
                && objResult.child && objResult.child.componentType !== "ctrl-slot"
            ) {
                objResult.child.customPath = newPath;
            }
            if (componentType === "ctrl-tabs") {
                this.$root.$emit("changeTab", { openCode: objResult.child.componentCode, componentPath: newPath, jumpToErrorData: objResult.child });
            } else if (componentType === "ctrl-stepper") {
                this.$root.$emit("goToStepper", { openCode: objResult.child.componentCode, componentPath: newPath, jumpToErrorData: objResult.child });
            } else if (componentType === "ctrl-collapsible") {
                this.$root.$emit("openCollapsible", { openCode: objResult.child.componentCode, componentPath: newPath, jumpToErrorData: objResult.child });
            } else if (componentType === "ctrl-segment") {
                let pathForSegment;
                if (newPath) {
                    pathForSegment = newPath.split(",");
                    pathForSegment.pop();
                    pathForSegment = pathForSegment.join();
                }

                this.$root.$emit("findPage", { openCode: objResult.componentCode, jumpToErrorData: objResult.child, componentPath: pathForSegment || newPath, indexSegment: objResult.componentIndex });
            } else if (componentType === "ctrl-segment-list") {
                this.$root.$emit("findInList", { openCode: objResult.componentCode, jumpToErrorData: objResult.child, indexSegment: objResult.componentIndex });
            } else if (objResult.child) {
                if (objResult.componentType === "ctrl-panel" || objResult.componentType === "ctrl-section") {
                    newPath = undefined;
                }
                this.openComponents(objResult.child, newPath);
            } else {
                let elementToJump;
                const elements = document.querySelectorAll(`[id='${objResult.componentId}']`);
                if (elements.length) {
                    if (elements.length > 1 && objResult.componentInitialPath) {
                        elementToJump = Array.from(elements).find(e => (e.getAttribute("path-id") === objResult.componentInitialPath));
                    } else {
                        elementToJump = elements[0];
                    }
                }

                if (elementToJump) {
                    const scrollToElement = (element) => {
                        const animateScroll = () => {
                            element.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
                            this.errorInJump = null;
                        };

                        if (this.isSmallScreen) {
                            requestAnimationFrame(animateScroll);
                        } else {
                            animateScroll();
                        }
                    };
                    scrollToElement(elementToJump);
                }
            }
        },

        jumpToError(error) {
            if (!this.errorInJump) {
                this.errorInJump = error.obj.componentInitialPath;
                this.openComponents(error.obj, true);
            }
        },

        reverseCreateObjectFromPath(path, initialPath) {
            if (path.length === 0) {
                return null;
            }

            const code = path.pop();
            const index = path.pop()
            const parent = this.reverseCreateObjectFromPath(path, initialPath);
            const obj = { code, parentCode: null, initialPath };

            if (parent) {
                obj.parentCode = { code: parent.code, index, parentCode: parent.parentCode, initialPath };
            }

            return obj;
        },

        notifyErrorsFound() {
            this.$toast.showNotify({
                caption: this.$tc("fabricInterface.submitErrorMessage", this.invalidFields.length),
                type: "error",
                message: this.$tc("fabricInterface.errorsFound", this.invalidFields.length, { count: this.invalidFields.length }),
                code: "app-saveNOk",
                timeout: 2000
            });
        }
    }
};
